import React from 'react'

import { Box, Button, LinearProgress, Typography } from '@material-ui/core'
import { Monitor as MonitorIcon, Book as BookIcon } from 'react-feather'

import helpers from 'helpers'
import { routes } from 'TrainingRoutes'
import useStyles from './styles'

const CourseCard = ({ course, portalToken }) => {
  const classes = useStyles()

  const progress = course.progress ?? 0
  const hasCertificate = course.completed && course.certificate
  const courseUrl = routes.courseDetail
    .replace(':portalToken', portalToken)
    .replace(':courseId', course.id)

  return (
    <Box component="a" href={courseUrl} className={classes.card}>
      {course.thumbnailUrl ? (
        <img
          src={course.thumbnailUrl}
          alt={course.title}
          className={classes.thumbnail}
        />
      ) : (
        <Box className={classes.thumbnailPlaceholder}>
          <MonitorIcon size={32} />
        </Box>
      )}
      <Box className={classes.body}>
        <Typography className={classes.title}>{course?.title}</Typography>
        <Box className={classes.progressRow}>
          <LinearProgress
            color="secondary"
            variant="determinate"
            value={progress}
            className={classes.progressBar}
            classes={{ barColorSecondary: classes.progressBarColor }}
          />
          <Typography className={classes.progressLabel}>{progress}%</Typography>
        </Box>
        {course.lessonsCount > 0 && (
          <Box className={classes.metaRow}>
            <BookIcon size={12} className={classes.metaIcon} />
            <Typography component="span" className={classes.metaRow}>
              {course.lessonsCount}{' '}
              {course.lessonsCount === 1 ? 'Aula' : 'Aulas'}
            </Typography>
          </Box>
        )}
        {course.lastAccessAt && (
          <Typography className={classes.lastAccess}>
            Acessado {helpers.formatters.dateFromNow(course.lastAccessAt)}
          </Typography>
        )}
        {hasCertificate && (
          <Button
            variant="outlined"
            size="small"
            fullWidth
            className={classes.certificateButton}
            href={course.certificate}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(event) => event.stopPropagation()}
          >
            Baixar Certificado
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default CourseCard
